"use strict";

var _taggedTemplateLiteral = require("/home/runner/work/prodigies-brochure/prodigies-brochure/node_modules/.pnpm/@babel+runtime@7.19.0/node_modules/@babel/runtime/helpers/taggedTemplateLiteral");

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  display: -webkit-box;\n  -webkit-line-clamp: ", ";\n  -webkit-box-orient: vertical;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TruncatedText = void 0;

var web_1 = require("@thesisedu/web");

var react_1 = __importDefault(require("react"));

var typography_1 = require("../typography");

function TruncatedText(_a) {
  var _a$textComponent = _a.textComponent,
      Text = _a$textComponent === void 0 ? typography_1.Body : _a$textComponent,
      numberOfLines = _a.numberOfLines,
      children = _a.children,
      rest = __rest(_a, ["textComponent", "numberOfLines", "children"]);

  return react_1.default.createElement(Container, Object.assign({
    children: children,
    as: Text,
    numberOfLines: numberOfLines
  }, rest));
}

exports.TruncatedText = TruncatedText;
var Container = web_1.styled.div(_templateObject(), function (props) {
  return props.numberOfLines;
});